export default {
  tableHeader: 'Benutzerdefinierte Felder',
};
